import { useState, useEffect } from 'react';
import { NodeDefinitionService } from '../services/NodeDefinitionService';

export interface NodeType {
  id: string;
  name: string;
  description: string | null;
  type: string;
  logo_url: string | null;
  category: string | null;
}

export function useNodeType(nodeType: string | undefined) {
  const [nodeTypeInfo, setNodeTypeInfo] = useState<NodeType | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    
    const fetchNodeTypeInfo = async () => {
      if (!nodeType) {
        setIsLoading(false);
        return;
      }

      try {
        // Utilizar o NodeDefinitionService para obter informações do nó pelo tipo
        const { data, error } = await NodeDefinitionService.getByFilters({ type: nodeType }, 1, 1);

        if (error) throw error;

        if (mounted && data && data.length > 0) {
          setNodeTypeInfo(data[0] as unknown as NodeType);
          setError(null);
        } else {
          setNodeTypeInfo(null);
          setError(new Error(`Node type '${nodeType}' not found`));
        }
      } catch (err) {
        if (mounted) {
          console.error('Error fetching node type info:', err);
          setError(err instanceof Error ? err : new Error(String(err)));
          setNodeTypeInfo(null);
        }
      } finally {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    fetchNodeTypeInfo();

    return () => {
      mounted = false;
    };
  }, [nodeType]);

  return { nodeTypeInfo, isLoading, error };
}
